import React from "react";

import { StyledErrorMessage } from "./styled";

type WithErrorFormProps = {
  touched?: boolean;
  errorMessage?: string;
};

export const WithErrorForm: React.FC<WithErrorFormProps> = ({
  touched,
  errorMessage,
  children,
}) => {
  return (
    <div>
      {children}
      {touched && errorMessage && (
        <StyledErrorMessage>{errorMessage}</StyledErrorMessage>
      )}
    </div>
  );
};
